<template>
  <div class="mod__account-process">
    <ProcessIndicator :status="accountProcess.code" />
    <ProcessTips />
    <ProcessActions
      :hidden-return-btn="hiddenReturnBtn"
      :show-problem-link="showProblemLink"
      :process="accountProcess"
      @back="close"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ProcessIndicator from './ProcessIndicator'
import RegistrationIcon from './RegistrationIcon'
import ProcessTips from './ProcessTips'
import ProcessActions from './ProcessActions'

export default {
  name: 'AccountStatusPanel',
  components: {
    ProcessActions,
    ProcessTips,
    ProcessIndicator,
    RegistrationIcon
  },
  props: {
    context: String,
    showProblemLink: {
      type: Boolean,
      default: true
    },
    hiddenReturnBtn: Boolean
  },
  watch: {
    language() {
      this.$store.dispatch('getAccountProcess')
    }
  },
  mounted() {
    this.$store.dispatch('getAccountProcess')
  },
  computed: {
    ...mapGetters(['accountProcess', 'language'])
  },
  methods: {
    close() {
      this.$emit('closeAccountStatus')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.mod__account-process {
  width: 320px;
  background-color: var(--bg-block);
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
